const cartDrawer = document.querySelector('cart-drawer');

if (cartDrawer) {
  const drawerOpenObserver = new MutationObserver(() => {
    if (cartDrawer.hasAttribute('open')) {
      console.log('🛒 Cart drawer opened');

      const discountContainer = document.querySelector('.miv__discount-container');
      if (!discountContainer) return;

      const waitForElement = (selector, callback) => {
        const el = document.querySelector(selector);
        if (el) return callback(el);

        const observer = new MutationObserver(() => {
          const el = document.querySelector(selector);
          if (el) {
            observer.disconnect();
            callback(el);
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      };

      waitForElement('.scDiscount__container', (scDiscountContainer) => {
       
        if (window._scDiscountObserver) {
          window._scDiscountObserver.disconnect();
        }

        const observer = new MutationObserver(() => {
          const successMessage = document.querySelector('.sc-message span');
          if (successMessage && successMessage.textContent.includes('wurde angewendet')) {
            console.log('✅ Rabatt erfolgreich angewendet. Container wird in 2 Sekunden geschlossen.');
            sessionStorage.setItem('miv_discountActive', '0');
          
              discountContainer.classList.remove('active');
              
              console.log('✅ Container geschlossen nach 2 Sekunden.');
            

            observer.disconnect();
          }
        });

        observer.observe(scDiscountContainer, {
          childList: true,
          subtree: true,
        });

       
        window._scDiscountObserver = observer;
      });
    }
  });

  drawerOpenObserver.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['open'],
  });
}
